import { WebSocketResponseMessage_OrderUpdate } from '../proto/generated/websocket.ts'
import { refetchPositionsAndOrders, setAppPrimaryTradingAccount } from '../services/apis/tradingAccount.ts'

class TradeManager {
    _publishOrderUpdatesToWebsocketManager?: (orderUpdate: WebSocketResponseMessage_OrderUpdate) => void

    setPrimaryTradingAccount(tradingAccountId: string) {
        setAppPrimaryTradingAccount(tradingAccountId)
    }

    updateOrders(orderUpdate: WebSocketResponseMessage_OrderUpdate) {
        this._publishOrderUpdatesToWebsocketManager && this._publishOrderUpdatesToWebsocketManager(orderUpdate);
    }

    shouldUpdateOrders(update: boolean) {
        if (update) {
            refetchPositionsAndOrders()
        }
    }
}

export default TradeManager